// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": () => import("./../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-contactame-js": () => import("./../src/pages/contactame.js" /* webpackChunkName: "component---src-pages-contactame-js" */),
  "component---src-pages-index-js": () => import("./../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-proyectos-js": () => import("./../src/pages/proyectos.js" /* webpackChunkName: "component---src-pages-proyectos-js" */),
  "component---src-pages-sobre-mi-js": () => import("./../src/pages/sobreMi.js" /* webpackChunkName: "component---src-pages-sobre-mi-js" */)
}

